// Shared strings of the 2026-10-03 ledger reports (export mixin, print
// header, AccountPicker, page stubs). Owned by the reports scaffold:
// report pages read them, never edit them. Path: finance.reports2.common.*
export default {
  companyFallback: "سناب درايف",
  company: "الشركة",
  period: "الفترة",
  from: "من",
  to: "إلى",
  date: "التاريخ",
  currency: "العملة",
  currencySyp: "ل.س",
  issuedAt: "تاريخ الإصدار",
  page: "صفحة",
  of: "من",
  total: "الإجمالي",
  refresh: "تحديث",
  apply: "تطبيق",
  exportExcel: "Excel",
  exportCsv: "CSV",
  print: "طباعة / PDF",
  expandAll: "توسيع الكل",
  collapseAll: "طي الكل",
  showAll: "عرض الكل",
  perPage: "عدد الأسطر في الصفحة",
  noData: "لا توجد بيانات",
  noMovements: "لا توجد حركات في هذه الفترة",
  tooManyRows: "عدد الحركات يتجاوز 10,000 سطر - يرجى تقليص الفترة",
  placeholder: "هذا التقرير قيد الإنشاء.",
  failedLoad: "تعذر تحميل التقرير",
  failedExport: "تعذر تصدير التقرير",
  popupBlocked: "تعذر فتح نافذة الطباعة - يرجى السماح بالنوافذ المنبثقة",
  debit: "مدين",
  credit: "دائن",
  balance: "الرصيد",
  balanced: "متوازن",
  notBalanced: "غير متوازن",
  account: "الحساب",
  accountCode: "رمز الحساب",
  accountName: "اسم الحساب",
  accountPicker: {
    label: "الحساب",
    hint: "ابحث بالرمز أو الاسم",
    noResults: "لا يوجد حساب مطابق",
    failedLoad: "تعذر تحميل دليل الحسابات",
    forbidden: "لا تملك صلاحية الاطلاع على دليل الحسابات",
    leafOnlyHint: "الحسابات الفرعية (بلا حسابات أبناء) فقط",
    inactive: "غير نشط",
  },
};
